.scrollRevealer {
	align-items: inherit;
	display: inherit;
	flex-direction: inherit;
	justify-content: inherit;
	opacity: 0;
}
